import EstateImportApiCheckerController from './controllers/fields/api-checker';
import EstateImportPlanController from './controllers/fields/import-plan';

window.application.register('estate-import_api-checker', EstateImportApiCheckerController);
window.application.register('estate-import_plan', EstateImportPlanController);
